import {
  MDBContainer, MDBNavItem, MDBNavLink, MDBNav,
} from 'mdbreact';
import React, { useContext, useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { UserContext } from '../Components/UserContext';
import PastEvents from '../Components/Admin/PastEvents';
import UpdateHours from '../Components/Admin/UpdateHours';
import AddEvent from '../Components/Admin/AddEvent';
import Search from '../Components/Admin/Search';
import AddUser from '../Components/Admin/AddUser';
import Filter from '../Components/Admin/Filter';

export default function Admin() {
  const baseURL = process.env.REACT_APP_API_BASEURL;
  const userContext = useContext(UserContext);

  const [waitForAuth, setWaitForAuth] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const [section, setSection] = useState(1);

  useEffect(() => {
    fetch(`${baseURL}/auth`, {
      headers: {
        Authorization: `${userContext.tokenID}`,
      },
    }).then((res) => {
      if (res.status >= 400) {
        setAuthorized(false);
        setWaitForAuth(false);
      } else {
        setAuthorized(true);
        setWaitForAuth(false);
      }
    });
  }, [userContext, baseURL]);

  if (waitForAuth) {
    return <h4>Loading</h4>;
  }

  if (!waitForAuth && !authorized) {
    return <Redirect to="/" />;
  }

  return (
    <>
      <MDBContainer
        className="rgba-stylish-slight"
        fluid
        style={{
          paddingLeft: '0',
          paddingRight: '0',
          paddingTop: '30px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        {section === 1 && <PastEvents />}
        {section === 1 && <AddEvent />}
        {section === 2 && <UpdateHours />}
        {section === 3 && <Search />}
        {section === 3 && <AddUser />}
        {section === 4 && <Filter />}
        <AdminNavbar handleSectionChange={setSection} />
      </MDBContainer>
    </>
  );
}

function AdminNavbar({ handleSectionChange }) {
  return (
    <div style={{ paddingTop: '50px' }}>
      <MDBNav
        expand="md"
        className="justify-content-center font-weight-bold"
        classicTabs
        style={{
          paddingBottom: '1.5rem',
          boxShadow: '5px -5px 5px gray',
        }}
      >
        <MDBNavItem style={{ width: '25vw', textAlign: 'center' }}>
          <MDBNavLink to="#" onClick={() => handleSectionChange(1)}>
            Events
          </MDBNavLink>
        </MDBNavItem>
        <MDBNavItem style={{ width: '25vw', textAlign: 'center' }}>
          <MDBNavLink to="#" onClick={() => handleSectionChange(2)}>
            Update Hours
          </MDBNavLink>
        </MDBNavItem>
        <MDBNavItem style={{ width: '25vw', textAlign: 'center' }}>
          <MDBNavLink to="#" onClick={() => handleSectionChange(3)}>
            Users
          </MDBNavLink>
        </MDBNavItem>
        <MDBNavItem style={{ width: '25vw', textAlign: 'center' }}>
          <MDBNavLink to="#" onClick={() => handleSectionChange(4)}>
            Filter
          </MDBNavLink>
        </MDBNavItem>
      </MDBNav>
    </div>
  );
}
